module.exports = __webpack_public_path__ + "static/media/star9.c135dad8.svg";